import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  dialogTitle: {
    color: 'rgb(48, 50, 107)',
    '&:selection': {
      color: 'rgb(255, 255, 255)',
      background: 'rgb(243, 92, 0) none repeat scroll 0% 0%'
    }
  }
}))
